<script setup lang="ts">
const { text } = defineProps<{ text?: string | null }>()
</script>

<template>
  <h1 v-if="text" class="hyphens-auto break-words">
    {{ text }}
  </h1>
</template>